import _defineProperty from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/defineProperty.js";
import _objectWithoutProperties from "/app/node_modules/next/dist/compiled/@babel/runtime/helpers/esm/objectWithoutProperties.js";
var _excluded = ["comments", "totalCount", "handleFetchMoreComments", "isLoading", "hiddenFromMembers", "useScrollToFocused"];

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

import { Box, Button, Divider, dividerClasses } from '@mui/material';
import * as A from 'fp-ts/Array';
import { constFalse, pipe } from 'fp-ts/function';
import * as Num from 'fp-ts/number';
import * as O from 'fp-ts/Option';
import * as Ord from 'fp-ts/Ord';
import { useEffect } from 'react';
import { Translation } from 'react-i18next';
import Comment from './comment';
import CommentPlaceholder from './comment-placeholder';
import { jsx as _jsx } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
export var ToggleButton = function ToggleButton(_ref) {
  var label = _ref.label,
      onClick = _ref.onClick;
  return /*#__PURE__*/_jsx(Button, {
    variant: "text",
    onClick: onClick,
    sx: {
      ml: {
        xs: 2,
        md: 9.5
      },
      color: function color(t) {
        return t.palette.neutral.main;
      }
    },
    "data-element": "Button",
    "data-component": "ToggleButton",
    "data-source-file": "comments-list.tsx",
    children: label
  });
};

var LoadMoreReplies = function LoadMoreReplies(_ref2) {
  var onClick = _ref2.onClick,
      numRepliesToShow = _ref2.numRepliesToShow;
  return numRepliesToShow > 0 ? /*#__PURE__*/_jsx(Button, {
    sx: {
      ml: {
        xs: 4,
        md: 9.5
      },
      mt: 1
    },
    onClick: onClick,
    children: /*#__PURE__*/_jsx(Translation, {
      children: function children(t) {
        return t('Load {{numRepliesToShow}} more replies', {
          numRepliesToShow: numRepliesToShow
        });
      }
    })
  }) : null;
};

var Placeholder = function Placeholder(_ref3) {
  var commentsToLoad = _ref3.commentsToLoad;
  return /*#__PURE__*/_jsx(Box, {
    sx: {
      display: 'flex',
      flexDirection: 'column',
      ml: {
        xs: 5,
        md: 10
      },
      gap: 3,
      mt: 2
    },
    "data-element": "Box",
    "data-component": "Placeholder",
    "data-source-file": "comments-list.tsx",
    children: A.makeBy(commentsToLoad, function (i) {
      return /*#__PURE__*/_jsx(CommentPlaceholder, {}, i);
    })
  });
};

export var COMMENTS_TO_FETCH = 5;
var withinLimit = Ord.clamp(Num.Ord)(0, COMMENTS_TO_FETCH);

var shouldFetchMoreComments = function shouldFetchMoreComments(focusedId, edges, totalCount) {
  return focusedId && edges.length !== totalCount && edges.every(function (edge) {
    return edge.node.id !== focusedId;
  });
};

export var FocusedCommentsList = function FocusedCommentsList(_ref4) {
  var comments = _ref4.comments,
      totalCount = _ref4.totalCount,
      handleFetchMoreComments = _ref4.handleFetchMoreComments,
      isLoading = _ref4.isLoading,
      hiddenFromMembers = _ref4.hiddenFromMembers,
      useScrollToFocused = _ref4.useScrollToFocused,
      commentsListProps = _objectWithoutProperties(_ref4, _excluded);

  var _useScrollToFocused = useScrollToFocused(),
      shouldHighlight = _useScrollToFocused.shouldHighlight,
      focusedRef = _useScrollToFocused.focusedRef,
      focusedCommentId = _useScrollToFocused.focusedCommentId;

  useEffect(function () {
    if (!isLoading && !hiddenFromMembers && shouldFetchMoreComments(focusedCommentId, comments, totalCount)) {
      handleFetchMoreComments();
    }
  }, [focusedCommentId, comments, totalCount, hiddenFromMembers]);
  return /*#__PURE__*/_jsx(CommentsList, _objectSpread(_objectSpread({
    comments: comments,
    totalCount: totalCount,
    isLoading: isLoading,
    hiddenFromMembers: hiddenFromMembers,
    handleFetchMoreComments: handleFetchMoreComments,
    focusedRef: focusedRef,
    focusedCommentId: focusedCommentId !== null && focusedCommentId !== void 0 ? focusedCommentId : undefined,
    shouldHighlight: shouldHighlight
  }, commentsListProps), {}, {
    "data-element": "CommentsList",
    "data-component": "FocusedCommentsList",
    "data-source-file": "comments-list.tsx"
  }));
};

var CommentsList = function CommentsList(_ref5) {
  var comments = _ref5.comments,
      newComment = _ref5.newComment,
      hiddenFromMembers = _ref5.hiddenFromMembers,
      profileId = _ref5.profileId,
      publicResponseId = _ref5.publicResponseId,
      focusedRef = _ref5.focusedRef,
      focusedCommentId = _ref5.focusedCommentId,
      _ref5$shouldHighlight = _ref5.shouldHighlight,
      shouldHighlight = _ref5$shouldHighlight === void 0 ? false : _ref5$shouldHighlight,
      totalCount = _ref5.totalCount,
      handleFetchMoreComments = _ref5.handleFetchMoreComments,
      handleHideComments = _ref5.handleHideComments,
      hasNextPage = _ref5.hasNextPage,
      isLoading = _ref5.isLoading;
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [totalCount > 0 ? /*#__PURE__*/_jsx(Translation, {
      children: function children(t) {
        return /*#__PURE__*/_jsxs(_Fragment, {
          children: [/*#__PURE__*/_jsx(ToggleButton, {
            onClick: handleHideComments,
            label: t("hideRepliesText", {
              count: totalCount
            })
          }), /*#__PURE__*/_jsx(Divider, {
            sx: {
              mt: 1
            }
          })]
        });
      }
    }) : null, hasNextPage ? /*#__PURE__*/_jsx(LoadMoreReplies, {
      numRepliesToShow: withinLimit(totalCount - comments.length),
      onClick: handleFetchMoreComments
    }) : null, isLoading ? /*#__PURE__*/_jsx(Placeholder, {
      commentsToLoad: withinLimit(totalCount - comments.length)
    }) : null, /*#__PURE__*/_jsx(Box, {
      sx: _defineProperty({}, ".MuiBox-root:last-child .".concat(dividerClasses.root), {
        display: {
          xs: 'none',
          md: hiddenFromMembers ? 'none' : 'inherit'
        }
      }),
      "data-element": "Box",
      "data-component": "CommentsList",
      "data-source-file": "comments-list.tsx",
      children: pipe(comments, A.reverse, A.map(function (_ref7) {
        var node = _ref7.node;
        return /*#__PURE__*/_jsx(Comment, _objectSpread({
          totalFetched: comments.length,
          profileId: profileId,
          publicResponseId: publicResponseId,
          innerSx: {
            ml: {
              xs: 5,
              md: 10
            }
          },
          comment: node,
          isNew: pipe(newComment, O.match(constFalse, function (newCommentId) {
            return newCommentId === node.id;
          })),
          hiddenFromMembers: hiddenFromMembers
        }, node.id === focusedCommentId ? {
          ref: focusedRef,
          isFocused: shouldHighlight
        } : {}), node.id);
      }))
    })]
  });
};

export default CommentsList;